import * as React from 'react';
import { connect } from 'react-redux';
import { AppState } from '../redux-modules/root';
import { ContainerProps } from './Container';
import { Switch, Route } from 'react-router-dom';
import { withSnackbar, WithSnackbarProps } from 'notistack';
import NotificationsFetchDetails from '../components/NotificationsFetchDetails';
import { domainPath } from '../App';
import DynamicNotifications from '../components/DynamicNotifications';
import DynamicNotificationDetails from '../components/DynamicNotificationDetails';
import { KeyUpService } from '../Services/KeyUpService';
import SoftSavedList from '../components/SoftSavedList';
import * as dynamicclient from '../redux-modules/dynamicclient';
import * as client from '../redux-modules/client';

interface MatchParams {
    index: string;
}

export interface NotificationsContainerState {
    isLoading: boolean;
    error: string;
    headerColor: string;
    org_type: any;
    is_Searched: boolean;
    isPartialListAvailable: boolean;
    PartialSavedList: string[];
    PaginationInfo: any;
    Config: string;
    subConfig: string;
    metaData: any;
}

type CallbackType = (result: boolean) => void;

export interface NotificationsContainerProps extends ContainerProps<MatchParams>, WithSnackbarProps {
    partialSavedList: (
        configType: string,
        subConfigType: string,
        is_accessToken: string,
        queryData?: any
    ) => Promise<void>;
    getSingleSavedClient: (id: string, Config: string, subConfig: string, accessToken: string, methodType: string) => Promise<void>;
    clearErrors: () => void;
}

export class NotificationsContainer extends React.Component<NotificationsContainerProps, NotificationsContainerState> {
    constructor(props: NotificationsContainerProps) {
        super(props);
        this.state = {
            isLoading: false,
            error: '',
            headerColor: '',
            org_type: null,
            is_Searched: false,
            isPartialListAvailable: false,
            PartialSavedList: [],
            PaginationInfo: {},
            Config: '',
            subConfig: '',
            metaData: {page: '1',
                       page_size: '25'}
        };
    }

    async componentDidMount() {
        const header_color: any = this.props.user && this.props.user.user.header_color;
        const org_type: any = this.props.user && this.props.user.user.org_type;
        this.setState({
            headerColor: header_color,
            org_type: org_type

        });
        const {Config, subConfig} = KeyUpService.getConfSubConf(this.props.location.pathname);
        this.setState({ subConfig: subConfig, Config: Config });
        this.setState({ isLoading: true })

        this.GetSoftSaveList(this.state.metaData, (result) => {

            if (result && result?.items?.length > 0) {
                this.setState((prevState) => ({
                    ...prevState,
                    isPartialListAvailable: true,
                    PartialSavedList: result.items,
                    PaginationInfo: result.meta
                }))

            }
            this.setState({ isLoading: false })
        })
    }

    async componentDidUpdate(prevProps, prevState) {
    
        if (this.props.location !== prevProps.location) {
            const {Config, subConfig} = KeyUpService.getConfSubConf(this.props.location.pathname);
          if (subConfig !== this.state.subConfig) {
           
           await this.setState({ subConfig: subConfig, Config: Config },
            () => this.GetSoftSaveList(this.state.metaData, (result) => {

                if (result && result?.items?.length > 0) {
                    this.setState((prevState) => ({
                        ...prevState,
                        isPartialListAvailable: true,
                        PartialSavedList: result.items,
                        PaginationInfo: result.meta
                    }))
    
                } else {
                    this.setState((prevState) => ({
                        ...prevState,
                        PartialSavedList: [],
                        PaginationInfo: {}
                    }))
                }
                this.setState({ isLoading: false })
            }));
            
          }
        }
        
      }

    isDataAvailable = () => {
        this.setState({
            is_Searched: false
        });
    };

    GetSoftSaveList = async (data, callback: (result) => void) => {
        const is_accessToken: any = this.props.user && this.props.user.user.accessToken;
        const { Config, subConfig } = KeyUpService.getConfSubConf(this.props.location.pathname);
        this.setState({ isLoading: true });
        try {
            let list: any = await this.props.partialSavedList(Config, subConfig, is_accessToken, data);
            callback(list?.response);
        } catch (error) {
            console.log(error);
            const { history } = this.props;
            if (error.status === 403) {
                history.push(`/${domainPath}/logout/`);
            }
        }
        this.setState({ isLoading: false });
    };

    loadSavedClient = async (id: string, methodType: string) => {
        this.props.clearErrors();
        const { history } = this.props;
        this.setState({ isLoading: true });
        const is_accessToken: any = this.props.user && this.props.user.user.accessToken;
        const { Config, subConfig } = KeyUpService.getConfSubConf(this.props.location.pathname);
        const res: any = await this.props.getSingleSavedClient(id, Config, subConfig, is_accessToken, methodType);
        this.setState({ isLoading: false });
        if (res !== null && res.hasOwnProperty('_id')) {
            //this.setState({ isSavedClientLoaded: true, tempDataId: res?._id })
            this.props.enqueueSnackbar('Client information loaded successfully.');
            history.push({
                pathname: `/${domainPath}/new-client/config=${Config}&subConfig=${subConfig}`,
                state: { temp_id: res?._id, isSavedClientLoaded: true }
            })
        } else if (res !== null) {
            this.props.enqueueSnackbar('Client information deleted successfully.');
            this.setState({ isLoading: true })
            this.GetSoftSaveList(this.state.metaData, (result) => {

                if (result && result?.items?.length > 0) {
                    this.setState((prevState) => ({
                        ...prevState,
                        isPartialListAvailable: true,
                        PartialSavedList: result.items,
                        PaginationInfo: result.meta
                    }))

                } else {
                    this.setState((prevState) => ({
                        ...prevState,
                        isPartialListAvailable: false,
                        PartialSavedList: [],
                        PaginationInfo: {}
                    }))
                }
                this.setState({ isLoading: false })
            })
            history.push(`/${domainPath}/notifications/config=${Config}&subConfig=${subConfig}`);
        }
        else {
            this.props.enqueueSnackbar('Permission denied. Please try again.');
        }
        return res?.data;
    };

    loadMetaInfo = (data) => {
        this.setState({ isLoading: true })
            this.GetSoftSaveList(data, (result) => {

                if (result && result?.items?.length > 0) {
                    this.setState((prevState) => ({
                        ...prevState,
                        isPartialListAvailable: true,
                        PartialSavedList: result.items,
                        PaginationInfo: result.meta
                    }))

                } else {
                    this.setState((prevState) => ({
                        ...prevState,
                        isPartialListAvailable: false,
                        PartialSavedList: [],
                        PaginationInfo: {}
                    }))
                }
                this.setState({ isLoading: false })
            })
    
    }


    render() {
        const is_accessToken: any = this.props.user && this.props.user.user.accessToken;
        const { client: clientState } = this.props;
        const clientList = (clientState && clientState.clientList) || {};
        const { is_Searched, isPartialListAvailable, PartialSavedList, isLoading, PaginationInfo } = this.state;
        const { Config, subConfig } = KeyUpService.getConfSubConf(this.props.location.pathname);
        const refferalInfo: any = this.props.user && this.props.user.user.referral_info;
        let tabLabel = refferalInfo.find((item) => item.config_type?.toString() === Config?.toString())?.referral_forms.find((list) => list.sub_config_type?.toString() === subConfig?.toString())?.label;
        const accessPermissions = this.props.user && this.props.user.user && this.props.user.user?.permissions["Notifications"];
        return (
            <Switch>
                <Route exact path={`/${domainPath}/notifications/fetching-client/client-details/config=:config&subConfig=:subConfig&index=:index`}>
                    <NotificationsFetchDetails
                        {...this.state}
                        clientList={is_Searched ? Object.values(clientList) : []}
                        clearData={this.isDataAvailable}
                    />
                </Route>
                <Route exact path={`/${domainPath}/notifications/config=:config&subConfig=:subConfig`}>
                    <DynamicNotifications
                         {...this.state}
                        accessToken={is_accessToken}
                        header_color={this.state.headerColor}
                        Config={Config}
                        subConfig={subConfig}
                        tabLabel={tabLabel}
                        PartialSavedList={PartialSavedList}
                        PaginationInfo={PaginationInfo}
                    />
                </Route>
                <Route exact path={`/${domainPath}/notifications/details/config=:config&subConfig=:subConfig&index=:id`}>
                    <DynamicNotificationDetails
                        accessToken={is_accessToken}
                        headerColor={this.state.headerColor}
                        Config={Config}
                        subConfig={subConfig}
                        tabLabel={tabLabel}
                        isLoading={isLoading}
                    />
                </Route>
                <Route exact path={`/${domainPath}/notifications/partialsave/config=:config&subConfig=:subConfig`}>
                    <SoftSavedList
                        {...this.props}
                        isPartialListAvailable={isPartialListAvailable}
                        PartialSavedList={PartialSavedList}
                        PaginationInfo={PaginationInfo}
                        loadMetaInfo={this.loadMetaInfo}
                        isLoading={isLoading}
                        loadSavedClient={this.loadSavedClient}
                        accessPermissions={accessPermissions}
                    // singleRecordLoading={this.singleRecordLoading}
                    />
                </Route>
            </Switch>
        );
    }
}

const mapStateToProps = (state: AppState) => {
    return {
        client: state.client,
        user: state.user,
        notifications: state.notifications
    };
};
const mapDispatchToProps = {
    partialSavedList: dynamicclient.actions.partialSavedList,
    getSingleSavedClient: dynamicclient.actions.getSingleSavedClient,
    clearErrors: client.actions.clearErrors,
};
export default connect(mapStateToProps, mapDispatchToProps)(withSnackbar(NotificationsContainer));